import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import gruppo from "../../assets/foto/gruppo-rievocatori.jpg";

function Ricostruzione() {
  const { t } = useTranslation();

  return (
    <section id="ricostruzione-storica" className="base-section">
      <div className="order-1 md:order-2">
        <div className="base-text-container">
          <h2 className="base-title">{t("ricostruzione.title")}</h2>
          <p className="base-paragraph">
            {t("ricostruzione.shortDescription")}
          </p>
          <Link to="/ricostruzione" className="base-link">
            {t("ricostruzione.more")}
            <i className="fas fa-angle-right ml-1 text-xl text-current"></i>
          </Link>
        </div>
      </div>
      <div className=" order-2 md:order-1">
        <img className="base-image" src={gruppo} alt="rievocatori" />
      </div>
    </section>
  );
}

export default Ricostruzione;
